<template>
  <div id="VehicleForm">
    <form class="form" @submit.prevent="addVehicle(vehicle)">
      <div class="form-group">
        <label>Organisation Assigned Code</label>
        <input
          type="text"
          v-model="vehicle.expan_code"
          class="form-control"
          placeholder="Expan Code"
        />
      </div>

      <div class="form-group">
        <label>Number Plate</label>
        <input
          type="text"
          v-model="vehicle.plate_no"
          class="form-control"
          placeholder="Number plate"
        />
      </div>

      <div class="form-group">
        <label>User Email</label>
        <input
          type="text"
          v-model="vehicle.email"
          class="form-control"
          placeholder="Email"
          />
      </div>

      <div>
        <button class="btn btn-primary btn-lg">Add vehicle</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "VehicleForm",
  data() {
    return {
      vehicle: {
        expan_code: "",
        plate_no: "",
        email: "",
      },
    };
  },
  methods: {
    addVehicle(vehicle) {
      axios({
        method: "post",
        url: "/vehicle/",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        data: vehicle,
      });
    },
  },
};
</script>

<style></style>
